import React from 'react';
import classNames from 'classnames';
import { OutlinedInput, Typography, withStyles } from '@material-ui/core';

const TextField = ({ classes, className, label, ...rest }) => {
  return (
    <div className={classNames(classes.container, className)}>
      <Typography variant="caption">{label}</Typography>
      <OutlinedInput
        labelWidth={0}
        className={classNames(classes.input, className)}
        classes={{
          inputMarginDense: classes.inputMarginDense,
          notchedOutline: classes.inputOutline,
          input: classes.input,
        }}
        margin="dense"
        fullWidth={false}
        {...rest}
      />
    </div>
  );
};

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputOutline: {
    border: 'none',
  },
  input: {
    backgroundColor: '#F2F2F7',
    textAlign: 'center',
    borderRadius: '5px',
  },
  inputMarginDense: {
    padding: theme.spacing(1) / 2,
    paddingTop: theme.spacing(1) / 2,
    paddingBottom: theme.spacing(1) / 2,
  },
});

export default withStyles(styles)(TextField);
